import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from "../http/api";

export class SpaceService {
    private changeAlert: ChangeAlertCallbackType;
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert;
    }

    async spaceCompanyCards(data) {
        const pos = getPosition();
        const response = await API.service('companyCards', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spaceCancel(data) {
        const pos = getPosition();
        const response = await API.service('cancelAccount', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spaceTxPending(data) {
        const pos = getPosition();
        const response = await API.service('spaceTxPending', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spaceTxPendingUpdate(data) {
        const pos = getPosition();
        const response = await API.service('spaceTxPendingUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spaceTxPendingGeneralUpdate(data) {
        const pos = getPosition();
        const response = await API.service('spaceTxPendingGeneralUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spacesGet(data) {
        const pos = getPosition();
        const response = await API.service('cuentas', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async spaceUpdate(data) {
        const pos = getPosition();
        const response = await API.service('spaceUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
}